<template>
  <div id="app" v-on:click="SetActive()">
    <topbar></topbar>
    <div class="appbody">
      <sidebar></sidebar>
      <router-view></router-view>
      <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
    </div>
    <footerbar> </footerbar>
  </div>
</template>
<style scoped>
.appbody {
  padding-left: 2%;
  padding-right: 2%;
  min-height: 90%;
  /* background-color: #f0f0e0; */
  background-image: linear-gradient(#f0f0e0, white);
}
</style>
<script>
import Vue from "vue";
import sidebar from "../components/sidebar.vue";
import topbar from "../components/topbar.vue";
import footerbar from "../components/footerbar.vue";
import Settings from "../lib/settings";
import { Api } from "../lib/api";
const api = new Api();

export default {
  components: { sidebar, topbar, footerbar },
  name: "maincontainer",
  created() {
    const kaIntms = Settings.keepAliveTimeMs;
    console.log(`Starting keepAlive with interval ${kaIntms}ms`);
    setInterval(this.KeepAlive, kaIntms); //Very frequent for dev purposes
  },
  methods: {
    KeepAlive() {
      api.keepalive()
        .then().catch(err => {
          alert(err);
        }
        );      
    },
    SetActive() {
      console.log('SetActive');
      localStorage.setItem('latestactive', JSON.stringify(new Date()));
    }
  },
};
</script>